import request from "@/utils/request";

export default function getAliyunOssSign(path) {
    return request({
        url: path,
        method: 'get',
    })
}
